// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hu","advertCardNum":"c-a_hv"};